export function getLabelByValue(dataArray: any, targetValue: string) {
  // Find the object where the 'value' matches the targetValue
  const matchedItem = dataArray.find((item: any) => item.value === targetValue)

  // Return the 'label' if found, otherwise return null
  return matchedItem ? matchedItem.label : null
}
